/**
 * Some records store display_name with a "Session: " / "Subject: " prefix while
 * the UI adds the same prefix from is_session — strip the redundant layer.
 */
export function stripRedundantPatientPrefix(displayName: string, isSession: boolean): string {
    const raw = (displayName || '').trim();
    if (!raw) return raw;
    const pattern = isSession ? /^session:\s*/i : /^subject:\s*/i;
    const stripped = raw.replace(pattern, '').trim();
    return stripped || raw;
}
